export const placeData = {
	title: "Información de contrato",
	description: "Información general de la cuenta",
	loading: "Cargando...",
	accessDenied: {
		title: "Acceso Denegado",
		description: "No tienes permisos para acceder a esta pantalla.",
	},
	error: {
		title: "Error",
		description: "Ocurrió un error al cargar los datos. Inténtalo de nuevo.",
	},
	sections: {
		general: {
			title: "General",
			description: "Información general de la cuenta",
		},
		fees: {
			title: "Tarifas",
			description:
				"Valores representan la tarifa que se aplicará a los elementos siguientes",
		},
		balanceModel: {
			title: "Modelo de saldo",
			description: "Definición de retorno del saldo",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Tipo de entrega configurado",
		},
		eventCurrency: {
			title: "Moneda del evento",
			description: "Moneda y proporción utilizada",
		},
		smartPosSettings: {
			title: "Configuraciones de SmartPOS",
			description: "Datos de integración",
		},
		communication: {
			title: "Comunicación",
			description: "Envío de mensajes (SMS y WhatsApp)",
		},
		charges: {
			title: "Cobranzas",
			description: "Productos y equipos adquiridos",
		},
	},
	fields: {
		contractNumber: "Número de contrato",
		profile: "Perfil",
		mainVersion: "Versión principal",
		guaranteedMonthlyMinimum: "Mínimo mensual garantizado",
		monthlyBillingCap: "Tope mensual de facturación",
		zigResponsible: "Responsable ZIG",
		placeStatus: "Estado del local",
		zigLocation: "Ubicación Zig",
		rechargeNotIntegratedLimit: "Límite de recarga no integrada",
		localResponsible: "Responsable(s) del local",
		minVersion: "Versión mínima del PDV",
		placeClassification: "Clasificación del local",
		smsNumbers: "Números para envío de SMS de ingresos",
		serviceFee: "Tarifa de servicio",
		deliveryFee: "Tarifa de entrega",
		processingFee: "Tarifa de procesamiento",
		platformFee: "Tarifa de la plataforma",
		status: {
			active: "Activo",
			blocked: "Bloqueado",
			inactive: "Inactivo",
			paused: "En pausa",
		},
		profileValues: {
			barAndRestaurant: "Bar y Restaurante",
			restaurant: "Restaurante",
			concertHall: "Teatro de Conciertos",
			bar: "Bar",
			nightclub: "Discoteca",
			park: "Parque",
			sportsArena: "Estadio Deportivo",
			other: "Otro",
		},
		parentPlaceName: "Lugar Padre",
		balanceReturnType: "Tipo de retorno del saldo",
		ppuAuthorizationValue: "Valor de la preautorización de la app",
		nonIntegratedPaymentLimit: "Límite de pago no integrado por dispositivo y evento",
		returnPeriod: "Período de retorno",
		minimumBalance: "Saldo mínimo",
		maximumBalance: "Saldo máximo",
		deliveryType: "Tipo de entrega",
		deliveryTime: "Tiempo de entrega",
		deliveryRadius: "Radio de entrega",
		currency: "Nombre",
		exchangeRate: "Proporción a la moneda del país",
		currencySymbol: "Símbolo",
		decimalPlaces: "Lugares decimales",
		integrationStatus: "Estado de integración",
		apiVersion: "Versión de API",
		lastSync: "Última sincronización",
		syncFrequency: "Frecuencia de sincronización",
		smsCost: "Costo del envío",
		whatsappCost: "Costo del envío",
		whatsappNumber: "Número",
		whatsappId: "ID del servicio",
		pushNotifications: "Notificaciones push",
		placeType: "Tipo de Place",
		placeTypesValues: {
			default: "Predeterminado",
			delivery: "Entrega",
			transfers: "Transferencias",
			advance: "Anticipo",
			billing: "Facturación",
		},
		accountType: "Tipo de cuenta",
		accountTypes: {
			conta_corrente: "Corriente",
			conta_poupanca: "Ahorro",
			conta_salario: "Nómina",
		},
		house: "Casa",
		zigFeeShouldBeChargedInDebit: "Cobrar tarifa Zig en la fecha de débito",
		hasCustomizedCard: "El depósito de garantía es del cliente",

		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Días hasta la liquidación de IFood",
				fee: "Tarifa iFood",
				description: "Configuraciones de IFood",
			},
		},
		delveryOnlineRules: "Reglas de entrega en línea",
		chargeBack: "Expirar al final del evento",
		placeOnly: "Gestionadas por la casa",
		normal: "Gestionadas por Zig",
		// Tasas y valores
		rateType: "Tipo",
		rateTypeLabel: "Tipo de tasa",
		singleRate: "Tasa única",
		segmentedFeeType: "Tasa segmentada",
		singleFeeType: "Tasa única",
		systemFee: "Tasa del sistema",
		inHouseConsumption: "Consumo en casa",
		ticketOfficeRevenue: "Ingresos de taquilla",
		rechargeSurplus: "Excedente de recarga",
		bonus: "Bonus",
		fixedFee: "Tasa fija",
		appFee: "Tasa sobre app",
		prechargeOnlinePaymentFee: "Tasa de pre-carga/pago en línea",
		fixedFeePaymentDay: "Día de pago de la tasa fija",
		anticipationFee: "Tasa de anticipación",
		thirdPartyPaymentFee: "Tasa de pago de terceros",
		// Pago con máquina ZigPay
		zigPayMachinePayment: "Pago con máquina ZigPay",
		debit: "Débito",
		credit: "Crédito",
		creditOtherFlags: "Crédito (Otras banderas)",
		debitOtherFlags: "Débito (Otras banderas)",
		replicateRatesForAllFlags: "¿Replicar tasas para todas las banderas?",
		pix: "Pix",
		pixKey: "Clave Pix",
		pixKeyType: "Tipo de Clave PIX",
		yes: "Sí",
		// Vale de alimentación
		foodVoucher: "Vale de alimentación",
		// Pago con máquina integrada en EC del cliente
		integratedMachinePayment: "Pago con máquina integrada en EC del cliente",
		machineCommission: "Comisión de las máquinas",
		anticipatedConsumption: "Consumo anticipado",
		anticipatedBar: "Anticipado/Bar",
		ticketOffice: "Taquilla",
		// Días hasta la cobranza
		daysUntilCollection: "Días hasta la cobranza",
		daysUntilCollectionDescription:
			"Cantidad de días para ejercer la cobranza y pagos en los siguientes formatos",
		collectionDaysDescription:
			"Cantidad de días para ejercer la cobranza y pagos en los siguientes formatos",
		// Parcelamiento
		installment: "Parcelamiento",
		installmentFee: "Tasa de parcelamiento",
		maxInstallments: "Número máx. de cuotas",
		bankAccountData: "Datos de cuenta bancaria",
		receivingAccount: "Compte de réception",
		recharges: "Recargas",
		rechargeValidityCriteria: "Validez y criterios de recarga",
		rechargesExpireIn: "Las recargas expiran en",
		remainingRechargeActions: "Acciones del saldo de recarga",
		digit: "Dígito",
		accountIdentification: "Identificación de la cuenta",
		accountIdentifier: "Identificador de la cuenta",
		cpfCnpj: "CPF/CNPJ",
		registrationData: "Datos para registrar",
		bankData: "Datos bancarios",
		branch: "Sucursal",
		bank: "Banco",
		account: "Cuenta",
		accountHolder: "Titular de la cuenta",
		documentType: "Tipo de documento",
		onlineDeliveryFee: "Tarifa de delivery online",
		advanceReservationFee: "Tarifa de cobranza anticipada en reservas",
		notApplicable: "No se aplica",
		// Cobranzas
		chargeTitle: "Título",
		chargeCategory: "Categoría",
		chargeRecurrence: "Recurrencia",
		chargeStartDate: "Inicio",
		chargeEndDate: "Fin",
		chargeInstallmentValue: "Valor de la cuota",
		installmentRate: "Tasa de parcelamiento",
		maxInstallmentsNumber: "Número máx. de cuotas",
		// Categorías de ajuste
		adjustmentCategories: {
			anticipationFee: "Tarifa de Anticipación",
			balanceAdjustment: "Ajuste de Saldo",
			bonifications: "Otras Bonificaciones",
			cardActivations: "Tarifa de Activación",
			equipmentsMaintenance: "Mantenimiento de Equipos",
			equipmentsPurchase: "Compra de Equipos",
			equipmentsRental: "Alquiler de Equipos",
			expiredRecharges: "Recargas Expiradas",
			generalZigMachineTax: "Tarifas de Adquirencia sobre Máquinas Integradas",
			generalZigMachineTPV: "Facturación vía adquirencia integrada ZIG",
			genericOperationsFee: "Gastos Generales de Operación",
			genericServices: "Otros Servicios y Cobranzas",
			notUsedRecharges: "Sobra de Recargas",
			operatorFee: "Tarifa Diaria de Operador",
			payments: "Pagos",
			paymentsTax: "Tarifa de Pago a Proveedores",
			pos: "Facturación en Máquinas No Integradas (POS)",
			posTax: "Tarifa de Adquirencia sobre Máquinas No Integradas (POS)",
			reimbursements: "Reembolsos a Clientes",
			systemSetup: "Configuración de Sistema",
			totemFee: "Tarifa de Totem",
			wifiAssistance: "Asistencia Técnica de Wifi",
			wifiSetup: "Configuración de Wifi",
			withdraw: "Retiros",
			zigDevicePurchase: "Compra de Comandas",
			zigFee: "Tarifa Zig",
			totenRental: "Alquiler de Totem",
			others: "Otros",
			renegotiation: "Renegociación",
			advance: "Adelanto",
			advanceFee: "Tarifa de Adelanto",
			balanceRetention: "Retención de Saldo",
			balanceTransfer: "Transferencia Entre Places",
			residueRemain: "Retención de Residuo",
			missingCards: "Tarjetas Extraviadas",
			billingInvoice: "Cobranza Nota Fiscal",
			guaranteedMinimumSupplement: "Complemento Mínimo Garantido",
			commandFiscalPurchase: "Compra de Comanda Fiscal",
			accountsReceivableLegal: "CR - Jurídico",
			cardDiscount: "Descuento de Tarjetas",
			discountGeneralOperatingExpenses: "Descuento Gastos Generales de Operación",
			discountOperatorDailyRate: "Descuento Tarifa Diaria de Operador",
			generalDiscount: "Descuento General",
			dailyCoordinatorRate: "Tarifas Diarias de Coordinadores",
			dailyHeadsRate: "Tarifas Diarias de Heads",
			setupDailyCoordinatorRate: "Tarifas Diarias de Setup Coordinadores",
			setupDailyHeadsRate: "Tarifas Diarias de Setup Heads",
			setupDailySupervisorsRate: "Tarifas Diarias de Setup Supervisores",
			setupDailyTechnicalRate: "Tarifas Diarias de Setup Técnico",
			setupDailyTraineeRate: "Tarifas Diarias de Setup Trainee",
			dailySupervisorRate: "Tarifas Diarias de Supervisores",
			dailyTechnicianRate: "Tarifas Diarias de Técnico",
			dailyTraineeRate: "Tarifas Diarias de Trainee",
			damagedEquipment: "Equipos Dañados",
			integratedAPPBilling: "Facturación App Integrado",
			apartCreditBilling: "Facturación Crédito Apartado",
			integratedCreditBilling: "Facturación Crédito Integrado",
			apartDebitBilling: "Facturación Débito Apartado",
			integratedDebitBilling: "Facturación Débito Integrado",
			apartBillingPIX: "Facturación PIX Apartado",
			integratedPIXBilling: "Facturación PIX Integrado",
			integratedAdvancedRechargeBilling: "Facturación Recarga Anticipado Integrado",
			interestandPenalties: "Intereses y Multa",
			softwareLicense: "Licencia de Software",
			replacedMachines: "Máquinas Reemplazadas",
			minimumGuaranteedpermachine: "Mínimo Garantido por máquina",
			otherEquipment: "Otros Equipos",
			rebate: "Rebate",
			setupAdvancedRecharge: "Configuración Recarga Anticipada",
			setupRefundSite: "Configuración Sitio de Reembolso",
			acquirementfeeforIntegratedZIGApplication:
				"Tarifa de adquirencia sobre Aplicativo ZIG Integrado",
			acquiringfeeonapartCredit: "Tarifa de adquirencia sobre Crédito Apartado",
			acquiringfeeforIntegratedCredit: "Tarifa de adquirencia sobre Crédito Integrado",
			acquiringfeeforapartDebit: "Tarifa de adquirencia sobre Débito Apartado",
			acquiringfeeonIntegratedDebit: "Tarifa de adquirencia sobre Débito Integrado",
			acquiringfeeforapartPIX: "Tarifa de adquirencia sobre PIX Apartado",
			acquiringfeeforIntegratedPIX: "Tarifa de adquirencia sobre PIX Integrado",
			acquiringfeeforAdvancedRecharge: "Tarifa de adquirencia sobre Recarga Anticipada",
			refundfee: "Tarifa de Reembolso",
			relatedpartyretentionfee: "Tarifa de retención de partes relacionadas",
			rappiFee: "Tarifa Rappi",
			SMSFee: "Tarifa SMS",
			residualFee: "Tarifa sobre Residuo",
			cardtoCashExchange: "Cambio de Tarjetas por Dinero",
			cardtoProductExchange: "Cambio de Tarjetas por Producto",
			travelFood: "Alimentación de Viaje",
			shipping: "Flete",
			accommodation: "Hospedaje",
			transport: "Transporte",
			pixRefundFee: "Tarifa Reembolso PIX",
			softwareLicenseMachine: "Licencia de Software Máquina",
			softwareLicenseTotem: "Licencia de Software Totem",
			integratedAdvanceDebitBilling: "Facturación Débito Antecipado Integrado",
			integratedAdvanceCreditBilling: "Facturación Crédito Antecipado Integrado",
			integratedAdvancePixBilling: "Facturación Pix Antecipado Integrado",
			integratedAdvanceDebitFee: "Tarifa Débito Antecipada Integrado",
			integratedAdvanceCreditFee: "Tarifa Crédito Antecipada Integrado",
			integratedAdvancePixFee: "Tarifa Pix Antecipada Integrado",
			integratedOnlineDeliveryIncome: "Facturación Delivery Online Integrado",
			zeDeliveryDiscount: "Descuento Zé Delivery",
			ticketPrinting: "Impresión de boletos",
			validatorRental: "Licencia de Validadores",
			zeDeliveryRetention: "Retención Zé Delivery",
			valueAddedTax: "IVA",
			moneyTPV: "TPV Dinero",
			acquiringFeeForIntegratedInstallmentCredit:
				"Tarifa de adquirencia sobre Crédito Parcelado Integrado",
			issuedCharge: "Cobranza Emitida",
			softwareLicenseGiftback: "Licencia de Software Giftback",
			loanBracelet: "Préstamo de pulsera",
			lendingCards: "Préstamo de tarjeta",
			externalResourceContribution: "Aporte de recursos externos",
			anticipationValue: "Valor de Anticipación",
			anticipatedValue: "Valor Antecipado",
			generalZigMachineCreditIn2Installments: "TPV Credito parcelado 2X",
			generalZigMachineCreditIn3Installments: "TPV Credito parcelado 3X",
			generalZigMachineCreditIn4Installments: "TPV Credito parcelado 4X",
			generalZigMachineCreditIn5Installments: "TPV Credito parcelado 5X",
			generalZigMachineCreditIn6Installments: "TPV Credito parcelado 6X",
			generalZigMachineCreditIn7Installments: "TPV Credito parcelado 7X",
			generalZigMachineCreditIn8Installments: "TPV Credito parcelado 8X",
			generalZigMachineCreditIn9Installments: "TPV Credito parcelado 9X",
			generalZigMachineCreditIn10Installments: "TPV Credito parcelado 10X",
			generalZigMachineCreditIn11Installments: "TPV Credito parcelado 11X",
			generalZigMachineCreditIn12Installments: "TPV Credito parcelado 12X",
			generalZigMachineCreditIn2InstallmentsFEE: "Tarifa Credito Parcelado 2X",
			generalZigMachineCreditIn3InstallmentsFEE: "Tarifa Credito Parcelado 3X",
			generalZigMachineCreditIn4InstallmentsFEE: "Tarifa Credito Parcelado 4X",
			generalZigMachineCreditIn5InstallmentsFEE: "Tarifa Credito Parcelado 5X",
			generalZigMachineCreditIn6InstallmentsFEE: "Tarifa Credito Parcelado 6X",
			generalZigMachineCreditIn7InstallmentsFEE: "Tarifa Credito Parcelado 7X",
			generalZigMachineCreditIn8InstallmentsFEE: "Tarifa Credito Parcelado 8X",
			generalZigMachineCreditIn9InstallmentsFEE: "Tarifa Credito Parcelado 9X",
			generalZigMachineCreditIn10InstallmentsFEE: "Tarifa Credito Parcelado 10X",
			generalZigMachineCreditIn11InstallmentsFEE: "Tarifa Credito Parcelado 11X",
			generalZigMachineCreditIn12InstallmentsFEE: "Tarifa Credito Parcelado 12X",
			totalTpvBarIncome: "Tarifa Recebimiento Bar",
			totalTpvEntranceIncome: "Tarifa Recebimiento Taquilla",
			totalTpvEntranceIncomeConsumption: "Tarifa Recebimiento Consumo Taquilla",
			totalTpvBarMinimumConsumption: "Tarifa Minima Recebimiento Bar",
			totalTpvBonus: "Tarifa Recebimiento Bonus",
			advanceRenegotiation: "Renegociación de Advance",
			zigTicketsRetention: "Retención Zig Tickets",
			onlineDeliveryAcquisitionFee: "Tarifa de Adquirencia sobre Delivery Online",
			bankRefund: "Reembolso bancario",
			acquirerRefund: "Reembolso adquirencia",
			pixPreventiveBlock: "Pix - Bloqueo Preventivo",
			pixAuthorizedUnblock: "Pix - Desbloqueo Autorizado",
			pixRefundByChargeback: "Pix - Reembolso por Chargeback",
			RelatedStakeholderRetentionReprocessing: "Retención y Reprocesamiento",
			cleaning: "Limpieza",
			electrical: "Eléctrica",
			hydraulics: "Hidráulica",
			supply: "Suministro",
		},
		// Recurrencias
		adjustmentRecurrences: {
			daily: "Diaria",
			event: "Por evento",
			monthly: "Mensual",
			weekly: "Semanal",
		},
	},
};
